import eventTracking from './event-tracking';
import titleoverlay from './titleoverlay';
import airplayButton from './airplay-button';
import chromecast from './chromecast';
import watermark from './watermark';
import ima from './ima';
import share from './share';
import qualityselector from './quality-selector';
import kijkwijzerPlugin from './kijkwijzer';

// You can add or remove plugins here
export const videoPlugins = {
  eventTracking,
  titleoverlay,
  airplayButton,
  chromecast,
  watermark,
  ima,
  share,
  qualityselector,
  kijkwijzerPlugin,
};

export const audioPlugins = {
  watermark,
  share,
};
